import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

const cases = [
  {
    testid: "case-study-card-0",
    image: "/assets/country-dance-lago-lugano-1200.webp",
    imageAlt: "Festa di paese sul lungolago: balli di gruppo country con DJ Magix al microfono",
    w: 1200,
    h: 675,
    tag: "Ente Pubblico — Festa di Paese",
    title: "Comune di Paradiso (Lugano)",
    text: "Per la festa pubblica del Comune di Paradiso ho curato l'intera serata: impianto audio e luci per la piazza, una scaletta pensata per tutte le generazioni e gran finale con la pista piena. Un onore suonare per il mio comune di casa.",
  },
  {
    testid: "case-study-card-1",
    image: "/assets/dj-magix-console-evento-1200.webp",
    imageAlt: "DJ Magix alla console durante un evento privato, con il logo proiettato",
    w: 1200,
    h: 1373,
    tag: "Agenzia Eventi — Internazionale",
    title: "Kika Events (Brasile)",
    text: "L'agenzia brasiliana Kika Events mi ha scelto per la parte musicale di un evento privato internazionale in Svizzera: repertorio internazionale, coordinamento a distanza con l'agenzia e una serata che ha unito ospiti da due continenti.",
  },
];

export default function CaseStudies() {
  const tr = useTr();
  const trCases = tr("cases.items", cases);
  const items = cases.map((c, i) => ({ ...c, ...(trCases[i] || {}) }));
  return (
    <section id="case-study" className="py-24 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow={tr("cases.eyebrow", "Case Study")}
          title={tr("cases.title", "Eventi in Evidenza")}
          accent={tr("cases.accent", "Due collaborazioni di cui vado particolarmente orgoglioso.")}
          testid="case-studies-heading"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-6 max-w-5xl mx-auto">
          {items.map((c, i) => (
            <motion.article
              key={c.testid}
              data-testid={c.testid}
              className="gold-frame rounded-xl bg-[#111111] overflow-hidden group"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="overflow-hidden">
                <img
                  src={c.image}
                  alt={c.imageAlt || c.title}
                  width={c.w}
                  height={c.h}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-56 object-cover saturate-[0.92] transition-all duration-700 group-hover:scale-105 group-hover:saturate-100"
                />
              </div>
              <div className="p-7">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#BFA45D]">
                  {c.tag}
                </p>
                <h3 className="font-display text-lg sm:text-xl font-semibold text-[#F7DE8B] mt-2">
                  {c.title}
                </h3>
                <p className="text-sm text-[#E2C882]/80 leading-relaxed mt-3">{c.text}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
